

























































































































import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api';
import ApplicationBar from '@/components/layout/applicationbar.vue';
import { Save } from '@/compositions/base-save';
import { VForm } from '@/types';

export default defineComponent({
  name: 'Reminder',
  components: { ApplicationBar },
  layout: 'plain',
  setup() {
    const { setSaveConfig, saveData, isRequired, valid, saveError } = Save();
    const router = useRouter();

    const form = ref<any>({});
    const formRef = ref<null | VForm>(null);

    const validate = (): void => {
      if (formRef.value?.validate()) {
        setSaveConfig('/api/v1/user/password_reminder', {
          success: 'パスワードの再発行をしました。',
          error: 'パスワードリマインダが失敗しました',
          doToast: true
        });
        saveData({ data: form.value }).then(() => {
          if (!saveError.value) {
            router.push('/reminder/completed');
          }
        });
      }
    };

    return {
      valid,
      isRequired,
      form,
      formRef,
      validate
    };
  }
});
